import { useCallback, useEffect, useRef, useState } from 'react';

export const OTP_RESEND_COOLDOWN_SEC = 60;

export default function useOtpResendCooldown(initialSeconds = OTP_RESEND_COOLDOWN_SEC) {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const endsAtRef = useRef(0);
  const timerRef = useRef(0);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      window.clearInterval(timerRef.current);
      timerRef.current = 0;
    }
  }, []);

  const tick = useCallback(() => {
    const remain = Math.max(0, Math.ceil((endsAtRef.current - Date.now()) / 1000));
    setSecondsLeft(remain);
    if (remain <= 0) clearTimer();
  }, [clearTimer]);

  const startCooldown = useCallback((seconds = initialSeconds) => {
    const sec = Math.max(0, Math.ceil(Number(seconds) || 0));
    if (sec <= 0) {
      endsAtRef.current = 0;
      setSecondsLeft(0);
      clearTimer();
      return;
    }
    endsAtRef.current = Date.now() + sec * 1000;
    setSecondsLeft(sec);
    clearTimer();
    timerRef.current = window.setInterval(tick, 250);
  }, [clearTimer, initialSeconds, tick]);

  const resetCooldown = useCallback(() => {
    endsAtRef.current = 0;
    setSecondsLeft(0);
    clearTimer();
  }, [clearTimer]);

  useEffect(() => () => clearTimer(), [clearTimer]);

  return {
    secondsLeft,
    canResend: secondsLeft <= 0,
    startCooldown,
    resetCooldown,
  };
}
